import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Send, CreditCard, PiggyBank, User } from "lucide-react";

const NAV_ITEMS = [
  { path: "/appmobile/dashboard", icon: LayoutDashboard, label: "Home" },
  { path: "/appmobile/cards",     icon: CreditCard,      label: "Cards" },
  null, // centre Transfer FAB slot
  { path: "/appmobile/savings",   icon: PiggyBank,       label: "Savings" },
  { path: "/appmobile/profile",   icon: User,            label: "Profile" },
];

export default function BottomNav() {
  const navigate     = useNavigate();
  const { pathname } = useLocation();

  const isActive = (p) =>
    pathname === p ||
    (p !== "/appmobile/dashboard" && pathname.startsWith(p + "/"));

  const isSend = pathname === "/appmobile/send" || pathname.startsWith("/appmobile/send/");

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 max-w-md mx-auto w-full"
      data-testid="bottom-nav"
    >
      <div className="bg-white/95 border-t border-slate-200 shadow-lg pt-1 pb-2 pb-safe">
        {/* 5-column grid — each item gets equal ~1/5 width, no squeezing on iOS */}
        <div className="grid grid-cols-5 items-end">

          {NAV_ITEMS.map((item, idx) => {
            /* ── Transfer FAB (centre slot) ── */
            if (item === null) {
              return (
                <button
                  key="nav-send"
                  data-testid="nav-send"
                  onClick={() => navigate("/appmobile/send")}
                  style={{ touchAction: "manipulation" }}
                  className="flex flex-col items-center -mt-5 w-full"
                >
                  <div className={`w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-all duration-200 active:scale-95 ${
                    isSend
                      ? "bg-[#0437A0] shadow-[#064BCB]/40"
                      : "bg-[#064BCB] shadow-[#064BCB]/30"
                  }`}>
                    <Send size={22} className="text-white" strokeWidth={2.2} />
                  </div>
                  <span className={`text-[10px] mt-1 font-medium ${isSend ? "text-[#064BCB]" : "text-slate-400"}`}>
                    Transfer
                  </span>
                </button>
              );
            }

            /* ── Regular nav item ── */
            const active = isActive(item.path);
            return (
              <button
                key={item.path}
                data-testid={`nav-${item.label.toLowerCase()}`}
                onClick={() => navigate(item.path)}
                style={{ touchAction: "manipulation" }}
                className={`flex flex-col items-center justify-end py-1.5 w-full rounded-xl transition-all duration-200 active:scale-95 ${
                  active
                    ? "text-[#064BCB] bg-[#EEF4FF]"
                    : "text-slate-400 hover:text-slate-700"
                }`}
              >
                <item.icon size={21} strokeWidth={active ? 2.5 : 1.8} />
                <span className={`text-[10px] mt-0.5 font-medium ${active ? "text-[#064BCB]" : "text-slate-400"}`}>
                  {item.label}
                </span>
              </button>
            );
          })}

        </div>
      </div>
    </nav>
  );
}
